import { coerce } from '../bytes.js';
const raw = bytes => coerce(bytes);
export const {name, code, encode, decode} = {
  name: 'raw',
  code: 85,
  decode: raw,
  encode: raw
};